import * as STEP_KEYS from "./stepKeys";

export const stepConfig = [
  {
    name: STEP_KEYS.SPECIALTY_TYPE,
    path: "SpecialtyTypeSelect",
    progress: "15%"
  },
  {
    name: STEP_KEYS.APPOINTMENT_TYPE,
    path: "AppointmentTypeSelect",
    progress: "35%"
  },
  { name: STEP_KEYS.PRACTITIONER, path: "PractitionerSelect", progress: "55%" },
  { name: STEP_KEYS.LOCATION, path: "LocationSelect", progress: "75%" },
  { name: STEP_KEYS.TIMEZONE, path: "TimeZoneSelect", progress: "90%" },
  {
    name: STEP_KEYS.APPOINTMENT_DATE_TIME,
    path: "ScheduleSelect",
    progress: "100%"
  }
];



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/consts/stepConfig.js